<script lang="ts">
  import type { StoryblokPostPreview } from "$types/atoms";
  // import ArrowLink from '$lib/atoms/ArrowLink.svelte';
  import PostCardSubheading from "$lib/molecules/newsroom/helper/PostCardSubheading.svelte";
  import { parseUrl } from "$lib/utils/helpers";
  import resizeImage from "$lib/utils/resizeImage";
  import { aspectRatio } from "$lib/utils/optimizeImage";

  export let post: StoryblokPostPreview;
  let isExternalLink = post?.content?.externalLink?.url?.length > 0;
</script>

{#if post && post.full_slug}
  <a
    href={post?.content?.externalLink?.url || "/" + parseUrl(post.full_slug)}
    target={isExternalLink ? "_blank" : ""}
    rel={isExternalLink ? "noopener noreferrer" : ""}
    class="flex flex-col no-underline group rounded-[var(--border-radius-wrapper)] overflow-hidden"
  >
    <div
      class="aspect-[384/202] object-cover object-center overflow-hidden group-hover:opacity-90 transition-opacity duration-300 {post
        ?.content?.mastheadImage?.filename
        ? ''
        : 'bg-[rgb(var(--color-yellow-primary))]'}"
    >
      {#if post?.content?.mastheadImage?.filename}
        <img
          class="w-full h-full object-cover"
          src={resizeImage(post.content.mastheadImage.filename)}
          alt={post.content.mastheadImage.alt}
          style={aspectRatio(post.content.mastheadImage.filename)}
          loading="lazy"
        />
      {/if}
    </div>

    <div
      class="py-[1.33rem] px-[1rem] flex flex-col flex-1 bg-[rgb(var(--color-warm-grey))]"
    >
      <div class="flex flex-col justify-between flex-1">
        <div class="space-y-[.75rem] max-w-[95%]">
          <PostCardSubheading {post} type="block-post-card" />
          <h4 class="type:h6-medium text-charcoal line-clamp-2">
            <span class="hover:underline"
              >{@html post?.content?.previewHeading || post.name}</span
            >
          </h4>
          {#if post?.content?.previewTeaser?.length > 0}<p
              class="type:body-small text-[#4B4B4B] line-clamp-1"
            >
              {post.content.previewTeaser}
            </p>{/if}
          <!-- {#if post.content.author}
						<p class="type:h5-eyebrow text-charcoal/50 leading-[1.3]">{post.content.author}</p>
					{/if} -->
        </div>

        <!-- <div>
					<ArrowLink class="reduced hover-red-bg">
						{#if post?.category_slug === 'podcasts'}
							Listen Now
						{:else if post.category_slug === 'videos'}
							Watch Now
						{:else}
							Read More
						{/if}
					</ArrowLink>
				</div> -->
      </div>
    </div>
  </a>
{/if}
